import React, { createContext, useContext, useEffect } from "react";
import { Modal, Form, Divider, Tag, notification } from "antd";

import TextArea from "antd/lib/input/TextArea";
import { Select } from "antd";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import AccountStore from "../../admin/accountcenter/store/accountStore";
import MainStore from "../../home/store/mainStore";
import moment from "moment";
import { observer } from "mobx-react-lite";
import RequestStore from "./store/requeststore";
import FormItem from "antd/lib/form/FormItem";
import { toJS } from "mobx";
import { useState } from "react";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";
import QuaiboDailyProductionStore from "../store/quaibodailyproductionstore";
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
const { Option } = Select;
const _ = require("underscore");
const mainStorectx = createContext(MainStore);
const requestStoreCtx = createContext(RequestStore);

export const RequestDialog = observer(() => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);
  const accountStore = useContext(AccountStore);
  const requestStore = useContext(requestStoreCtx);
  const mainStore = useContext(mainStorectx);
  const [comment, setComment] = useState("");
  useEffect(() => {
    async function loadAllUsers() {
      try {
        await accountStore.loadAllUsers();
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    }
    loadAllUsers();
  }, []);
  return (
    <Modal
      centered
      title={`Request for ${mainStore.assetContextName} Production Entry Approval`}
      visible={requestStore.showRequestDialog}
      onOk={async () => {
        try {
          let requestorId = getCurrentUser()?.id;
          let approverId = requestStore.selApprover;
          let productionIds = [];
          const assetId = mainStore.assetContextId;
          if (assetId === 1) {
            productionIds = requestStore.producingDays.map(
              (p) => toJS(p).naocDailyProductionId
            );
          } else if (assetId === 2) {
            productionIds = requestStore.producingDays.map(
              (p) => toJS(p).ebendoDailyProductionId
            );
          } else if (assetId === 3) {
            productionIds = requestStore.producingDays.map(
              (p) => toJS(p).quaiboDailyProductionId
            );
          }
          const retVal = await requestStore.submitRequest(
            approverId,
            requestorId,
            comment,
            productionIds,
            assetId
          );

          if (retVal.isValid) {
            const { productions } = retVal;
            if (assetId === 1) {
              productions.forEach((prod) => {
                naocDailyProductionStore.dailyProductions.set(
                  prod.naocDailyProductionId,
                  {
                    ...prod,
                    productionDate: moment(prod.productionDate).format("L"),
                    strippedSARemarks: prod.swampAreaRemarks
                      ? prod.swampAreaRemarks.replace(/(<([^>]+)>)/gi, " ")
                      : null,
                    strippedLARemarks: prod.landAreaRemarks
                      ? prod.landAreaRemarks.replace(/(<([^>]+)>)/gi, " ")
                      : null,
                    pdYear: moment(prod.productionDate).format("YYYY"),
                    pdYearMonth: moment(prod.productionDate).format("YYYY-MMM"),
                  }
                );
              });
            } else if (assetId === 2) {
              productions.forEach((prod) => {
                ebendoDailyProductionStore.dailyProductions.set(
                  prod.ebendoDailyProductionId,
                  {
                    ...prod,
                    productionDate: moment(prod.productionDate).format("L"),
                    strippedRemarks: prod.remarks
                      ? prod.remarks.replace(/(<([^>]+)>)/gi, " ")
                      : null,

                    pdYear: moment(prod.productionDate).format("YYYY"),
                    pdYearMonth: moment(prod.productionDate).format("YYYY-MMM"),
                  }
                );
              });
            } else if (assetId === 3) {
              productions.forEach((prod) => {
                quaiboDailyProductionStore.dailyProductions.set(
                  prod.quaiboDailyProductionId,
                  {
                    ...prod,
                    productionDate: moment(prod.productionDate).format("L"),
                    strippedRemarks: prod.remarks
                      ? prod.remarks.replace(/(<([^>]+)>)/gi, " ")
                      : null,

                    pdYear: moment(prod.productionDate).format("YYYY"),
                    pdYearMonth: moment(prod.productionDate).format("YYYY-MMM"),
                  }
                );
              });
            }

            console.log(productions);

            notification.success({
              message: "SPARS Feedback",
              description: "request(s) submitted sucesfully",
            });
          }
        } catch (error) {
          notification.error({
            message: "SPARS Feedback",
            description: `request submission failed because the selected producing day ${
              error.response && error.response.text
            }`,
          });
        } finally {
          requestStore.producingDays = [];
          requestStore.showRequestDialog = false;
          requestStore.selReqItem = {};
          const grid = requestStore.productionGrid;
          grid.api.deselectAll();
        }
      }}
      onCancel={() => {
        requestStore.showRequestDialog = false;
      }}
      okText="Submit"
      okButtonProps={{
        disabled: !requestStore.selApprover,
        loading: requestStore.isLoading,
      }}
    >
      <Form layout="vertical">
        <FormItem label="Approver" required labelAlign="top">
          <Select
            showSearch
            placeholder="Select an approver"
            optionFilterProp="children"
            onChange={(val, obj) => {
              console.log(val, obj);
              requestStore.approverParty = obj.key;
              requestStore.selApprover = val;
            }}
            filterOption={(input, option) => {
              // console.log(input, option);
              return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }}
          >
            {_.sortBy(
              _.filter(
                [...accountStore.users.values()],
                (x) => x.id !== getCurrentUser().id
              ),
              "firstName"
            ).map((u) => (
              <Option value={u.id} key={`${u.fullName}`}>
                <div className="ms-Grid" dir="ltr">
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm7">
                      <b>{u.firstName}</b>, {u.lastName}
                    </div>
                    <div className="ms-Grid-col ms-sm5">
                      <small>{u.jobFunction}</small>
                    </div>
                  </div>
                </div>
              </Option>
            ))}
          </Select>
        </FormItem>

        <FormItem required label="Requestor Comment" labelAlign="top">
          <TextArea
            label=" "
            rows={5}
            name="description"
            value={comment}
            onChange={({ target }) => {
              setComment(target.value);
            }}
          />
        </FormItem>
        <Divider>Approval for:</Divider>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <span style={{ color: "red", fontWeight: "bold" }}>
                {requestStore.producingDays.length}
              </span>{" "}
              Producing Day{requestStore.producingDays.length > 1 ? "s" : ""}
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              {requestStore.producingDays.slice().sort().map((d) => (
                <Tag key={d.productionDate}>
                  {" "}
                  {moment(d.productionDate).format("dddd MMM Do YYYY")}
                </Tag>
              ))}
            </div>
          </div>
        </div>
        <Divider />
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm3">Requestor:</div>
            <div className="ms-Grid-col ms-sm9">
              {getCurrentUser()?.fullName}
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm3">Request Date:</div>
            <div className="ms-Grid-col ms-sm9">
              {moment(new Date()).format("LLL")}
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm3">Approver Party:</div>
            <div className="ms-Grid-col ms-sm9" style={{ color: "red" }}>
              <b>{requestStore.approverParty}</b>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
});

